import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  doc,
  deleteDoc,
  setDoc,
  orderBy,
  updateDoc,
  limit
} from "firebase/firestore";
import Cookies from "js-cookie";
import { Randomcode } from "./components_root/rendom_code";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
} from "firebase/auth";

import { Rendom_number } from "./components_root/rendom_number";
// Firebase config from env variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

provider.setCustomParameters({ prompt: "select_account" });



// Sign in with Google function
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    const emailid = user.email?.trim().toLowerCase();
    if (!emailid) throw new Error("Email not found.");

    let account_guid = "";
    let displayName = user.displayName || "Unknown";
    let photoURL = user.photoURL || "";
  
    let referral_account = "";
    let currency_code = "USD";
    let address_key = "";
    // 🔍 1. Check if the account already exists based on email
    const checkQuery = query(
      collection(db, "accounts"),
      where("email", "==", emailid)
    );
    const checkSnap = await getDocs(checkQuery);

    if (!checkSnap.empty) {
      // ✅ Existing User: skip creating
      const userDoc = checkSnap.docs[0];
      const userData = userDoc.data();

      account_guid = userData.guid;
      displayName = userData.name || displayName;
      photoURL = userData.photoURL || photoURL;

      currency_code = userData.currency_code || currency_code;
     
      // Optional: update last login time
      await updateDoc(doc(db, "accounts", account_guid), {
        updated_datetime: new Date(),
      });
      console.log("✅ Existing user login");
    } else {
      // 🆕 New User Creation

 

      // 3. Get Geo + Device Info from cookies
      const usercity = Cookies.get("city") || "";
      const userpostcode = Cookies.get("postcode") || "";
      const userstate = Cookies.get("state") || "";
      const usercountryname = Cookies.get("country") || "";
      const useraddress = Cookies.get("address") || "";
      const userlatitude = Cookies.get("latitude") || "";
      const userlongitude = Cookies.get("longitude") || "";
      const deviceName = Cookies.get("deviceName") || "Unknown Device"; 
      // 4. Get available wallet address 
      account_guid = Randomcode(22); 
      // Mark wallet as used      
      // 5. Generate user fields
      const slug = Randomcode(12).toLowerCase(); 
      // 6. Save user account
      const newUserRef = doc(db, "accounts", account_guid);
      await setDoc(newUserRef, {
        guid: account_guid,
        uid: account_guid,
        email: emailid,
        name: displayName,
        city: usercity,
        postcode: userpostcode,
     
        photoURL,
        currency_code,
        referral_code: Randomcode(9),
        referral_account,
        
        state: userstate,
        country: usercountryname,
        address: useraddress,
        latitude: userlatitude,
        longitude: userlongitude,
        device: navigator.userAgent,
        deviceName,
        rating: 1,
        reviews: 0,
        slug,
        status: true,
        verification: false,
        bio: "Short profile description",
        verification_date_time: new Date(),
        updated_date_time: new Date(),
        date_time: new Date(),
      });
      Cookies.remove("referral_code");
      console.log("✅ New user account created");
    }

    // 7. Create login session
    const uid = Randomcode(12);
    const loginRef = doc(db, "accounts_login", uid);
    await setDoc(loginRef, {
      guid: account_guid,
      uid,
      sessiontoken: uid,
      name: displayName,
      email: emailid,
      city: Cookies.get("city") || "",
      postcode: Cookies.get("postcode") || "",
      state: Cookies.get("state") || "",
      country: Cookies.get("country") || "",
      latitude: Cookies.get("latitude") || "",
      longitude: Cookies.get("longitude") || "",
      photoURL,
      deviceName: Cookies.get("deviceName") || "Unknown Device",
      device: navigator.userAgent,
      emailuid: user.uid,
      app_version: "1.1.5",
      status: true,
      date_time: new Date(),
    });

    // 8. Set session cookies
   // Root domain + subdomains 
// One for session token
const testing =false;
if(testing ===true)
{
Cookies.set("sessiontoken", uid, { expires: 365, path: "/" });
Cookies.set("guid", account_guid, { expires: 365, path: "/" });
Cookies.set("currency_code", currency_code, { expires: 365, path: "/" }); 
Cookies.set("login_photoURL", photoURL, { expires: 1, path: "/" });

}
else{
Cookies.set("sessiontoken", uid, { 
  expires: 365, 
  domain: ".viabig.com", 
  secure: true, 
  path: "/" 
});

// One for account guid
Cookies.set("guid", account_guid, { 
  expires: 365, 
  domain: ".viabig.com", 
  secure: true, 
  path: "/" 
});
// One for account guid
Cookies.set("login_photoURL", photoURL, { 
  expires: 365, 
  domain: ".viabig.com", 
  secure: true, 
  path: "/" 
});

// Currency code
Cookies.set("currency_code", currency_code, { 
  expires: 365, 
  domain: ".viabig.com", 
  secure: true, 
  path: "/" 
});
 
}

    return { 
      guid: account_guid,
      email: emailid,
      name: displayName,
      photoURL,
    };
  } catch (error) {
    console.error("❌ Google Sign-In Error:", error.message || error);
    return null;
  }
};



// Check auth state
export const checkUserAuth = (setUser) => {
  // onAuthStateChanged(auth, async (user) => {
  //   if (user) {
  //     const email = user.email?.toLowerCase();
  //     const checkQuery = query(collection(db, "accounts"), where("email", "==", email));
  //     const checkSnap = await getDocs(checkQuery);

  //     if (!checkSnap.empty) {
  //       const data = checkSnap.docs[0].data();
  //       setUser({
  //         guid: data.guid,
  //         email: data.email,
  //         name: data.name,
  //         photoURL: data.photoURL
  //       });
  //     }
  //   } else {
  //     setUser(null);
  //   }
  // });
};
// Logout function
export const googleLogout = async () => {
  try {
    await signOut(auth);

    const cookieOptions = { domain: ".viabig.com", path: "/" };

    Cookies.remove("sessiontoken", cookieOptions);
    Cookies.remove("login_photoURL", cookieOptions);
    Cookies.remove("guid", cookieOptions);
    Cookies.remove("currency_code", cookieOptions);

    window.location.href = "/";
  } catch (error) {
    console.error("❌ Logout Error:", error);
  }
};

export { auth, provider, db };
